// extracted by mini-css-extract-plugin
export default {"Token":"SingleSelectToken-module__Token--FOSN8","colorIndicator":"SingleSelectToken-module__colorIndicator--mFcTC"};